import { formatDateWithStoreDep } from "utils/store-dependent-helpers";

import { DateString } from "./types";

/*
 * Used specifically in non-tabular UIs (forms, drawers, cards, etc.)
 * to render a short-form date.
 */
export function formatUiDateShort(dateString: DateString) {
  return formatDateWithStoreDep(dateString, {
    format: {
      dateStyle: "short",
    },
  });
}

export function formatUiDateLong(dateString: DateString) {
  return formatDateWithStoreDep(dateString, {
    format: {
      dateStyle: "long",
    },
  });
}

/*
 * Used in tables to render a cell-friendly date.
 */
export function formatTableDate(dateString: DateString) {
  return formatDateWithStoreDep(dateString);
}
